import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PayoutItemContent from './PayoutItemContent';
import * as actions from './PayoutItemContent.actions';

const Connected = connect(
    function mapStateToProps(state) {
        return {
            paymentSystems: state.paymentSystems.list,
            paymentDetails: state.paymentDetails.list,
            payout: state.publisherPayouts.item
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getPaymentSystems: actions.getPaymentSystems,
            getPaymentDetails: actions.getPaymentDetails,
            getPublisherPayoutItem: actions.getPublisherPayoutItem,
            cancelPublisherPayout: actions.cancelPublisherPayout
        };
    }
)(PayoutItemContent);

export default function PayoutItemContentContainer(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
        <Connected
            {...props}
            location={{ pathname: location.pathname, query: location.search }}
            navigate={navigate}
            params={params}
        />
    );
}
